module.exports = __webpack_public_path__ + "static/pocket-ebc28e8e1e829bcfffe078c2c0ab2079.jpg";